import React from 'react';

import { usePageType } from '../../hooks/routes';
import { PAGE_TYPE } from '../../interfaces/routes';

import { List } from './containers/List';
import { MainList } from './containers/MainList';
import { PartnersList, OrgNewsList, RubricList } from './containers/Rubric';
import { TagList } from './containers/Tag';

export const ListContent = () => {
  const pageType = usePageType();

  switch (pageType) {
    case PAGE_TYPE.MAIN:
      return <MainList />;
    case PAGE_TYPE.TAG:
      return <TagList />;
    case PAGE_TYPE.RUBRIC:
      return <RubricList />;
    case PAGE_TYPE.PARTNERS:
      return <PartnersList />;
    case PAGE_TYPE.PARTNER:
      return <OrgNewsList />;
    default:
      return <List />;
  }
};
